/** React */
import {
  HtmlHTMLAttributes,
} from "react";

/** CSS */
import "./index.css";

import Button from "../button";
import { RiMapPinTimeFill, RiMapPinTimeLine } from "react-icons/ri";
import { useTheme } from "../../context/theme";

/** Props */
type Props = HtmlHTMLAttributes<HTMLDivElement> & {
  thumbPosition?: string;
  handleOverContent: (value: string | number | undefined) => void;
  handleDownThumb: () => void;
};

export function RangeThumb({
  thumbPosition,
  handleOverContent,
  handleDownThumb
}: Props) {
  const { dataTheme } = useTheme();

  
  return (
    <Button
      mode="icon"
      className="range__thumb"
      size="small"
      style={{
        left: `${thumbPosition}`,
      }}
      onMouseOver={() => handleOverContent(thumbPosition)}
      onMouseDown={handleDownThumb}
    >
      {dataTheme === "dark" ? (
        <RiMapPinTimeFill size="1.5rem" />
      ) : (
        <RiMapPinTimeLine size="1.5rem" />
      )}
    </Button>
  );
}
